import { render } from "./AddressSection.vue?vue&type=template&id=176ce09c&scoped=true"
import script from "./AddressSection.vue?vue&type=script&lang=js"
export * from "./AddressSection.vue?vue&type=script&lang=js"

import "./AddressSection.vue?vue&type=style&index=0&id=176ce09c&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-176ce09c"]])

export default __exports__